<template>
    <v-layout v-if="ready" justify-center>
        <v-responsive max-width="1024px" width="100%" height="100%" class="shop-board-view" style="overflow: visible">
            <div v-if="!$route.query._board" class="headline text-start mt-8">게시글 등록</div>
            <div v-else class="headline text-start mt-8">게시글 상세</div>

            <v-card class="mt-4">
                <v-card-title class="subtitle-1 pb-0">기본정보</v-card-title>
                <v-card-text>
                    <v-row v-if="$route.params._board">
                        <v-col cols="4" class="py-0">
                            <v-text-field :value="(board.writer || {}).name" label="작성자" persistent-placeholder hide-details readonly disabled></v-text-field>
                        </v-col>
                        <v-col cols="4" class="py-0">
                            <v-text-field :model-value="$dayjs(board.createdAt).format('YYYY-MM-DD')" label="실제 작성일" persistent-placeholder hide-details readonly disabled></v-text-field>
                        </v-col>
                        <v-col cols="4" class="py-0">
                            <v-text-field v-model="board.updatedAt" label="최종수정일*('YYYY-MM-DD' 형식을 지켜주세요)*" hide-details></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mt-3" v-if="['notice'].includes(board.code)">
                        <v-col cols="auto" class="py-0">
                            <v-row class="ma-n1" align="center" style="height: 56px">
                                <v-col class="pa-1" cols="auto"> 게시기간 </v-col>
                                <v-col class="pa-1" cols="auto">
                                    <v-switch v-model="board.displayPeriod.uses" hide-details class="ma-0 pa-0" />
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col class="py-0">
                            <v-expand-transition>
                                <div v-show="board.displayPeriod.uses">
                                    <v-row align="center" class="ma-n1">
                                        <v-col class="pa-1">
                                            <v-datetime-field
                                                v-model="board.displayPeriod.beginsAt"
                                                label="시작일시"
                                                :attrs_input="{
                                                    'persistent-placeholder': true,
                                                    'hide-details': true,
                                                }"
                                                clearable
                                            />
                                        </v-col>
                                        <v-col class="pa-1" cols="auto"> ~ </v-col>
                                        <v-col class="pa-1">
                                            <v-datetime-field
                                                v-model="board.displayPeriod.closesAt"
                                                label="종료일시"
                                                :attrs_input="{
                                                    'persistent-placeholder': true,
                                                    'hide-details': true,
                                                }"
                                                clearable
                                            />
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-expand-transition>
                        </v-col>
                    </v-row>
                    <v-row class="mt-3">
                        <v-col cols="12" class="py-0">
                            <v-text-field v-model="board.subject" label="제목" persistent-placeholder hide-details></v-text-field>
                        </v-col>
                        <v-col v-if="['volunteer', 'event', 'library'].includes(board.code)" cols="12" class="py-0">
                            <v-text-field v-model="board.summary" label="한줄설명" persistent-placeholder hide-details class="mt-4"></v-text-field>
                        </v-col>
                        <v-col v-if="['library'].includes(board.code)" cols="12" class="py-0">
                            <v-text-field v-model="board.url" label="온라인 연차보고 URL" persistent-placeholder hide-details class="mt-4"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row v-if="['event'].includes($route.query.code || board.code)" class="mt-6">
                        <v-col cols="6" class="py-0">
                            <v-switch v-model="board.isNotice" label="진행여부" />
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-card class="mt-4" v-if="['volunteer', 'event', 'news', 'newsletter', 'fair', 'supporter', 'library'].includes(board.code)">
                <v-card-title class="subtitle-1">썸네일</v-card-title>
                <v-card-text>
                    <v-row align="center">
                        <v-col cols="auto" class="py-0">
                            <v-img v-if="board.thumb" max-width="96" max-height="96" :src="createObjectURL(board.thumb)" contain></v-img>
                            <v-responsive v-else width="96" height="96" class="grey lighten-2">
                                <v-row align="center" class="fill-height" justify="center"><v-icon color="black">mdi-pencil</v-icon></v-row>
                            </v-responsive>
                        </v-col>
                        <v-col class="py-0">
                            <v-file-input v-model="board.thumb" label="썸네일 이미지" persistent-placeholder class="mt-2 mx-3" show-size accept="image/*"></v-file-input>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-card v-if="['news', 'operation', 'reference', 'notice', 'report', 'newsletter', 'fair', 'supporter', 'library', 'finance'].includes(board.code)" class="mt-4">
                <v-card-title class="subtitle-1">첨부파일1</v-card-title>
                <v-card-text>
                    <v-file-input v-model="board.files[0]" show-size />
                </v-card-text>
            </v-card>
            <v-card v-if="['operation', 'reference', 'notice', 'report', 'newsletter', 'fair', 'supporter'].includes(board.code)" class="mt-4">
                <v-card-title class="subtitle-1">첨부파일2</v-card-title>
                <v-card-text>
                    <v-file-input v-model="board.files[1]" show-size />
                </v-card-text>
            </v-card>
            <v-card v-if="['operation', 'reference', 'notice', 'report', 'newsletter', 'fair', 'supporter'].includes(board.code)" class="mt-4">
                <v-card-title class="subtitle-1">첨부파일3</v-card-title>
                <v-card-text>
                    <v-file-input v-model="board.files[2]" show-size />
                </v-card-text>
            </v-card>

            <v-card class="mt-6" v-if="!['library', 'finance'].includes(board.code)">
                <v-card-title class="subtitle-1">내용</v-card-title>
                <v-card-text>
                    <naver-smarteditor v-model="board.content" id="content" rows="10"></naver-smarteditor>
                </v-card-text>
            </v-card>

            <v-row justify="center">
                <v-col md="auto" sm="auto">
                    <v-btn color="primary" @click="save">저장</v-btn>
                </v-col>
            </v-row>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import dayjs from "dayjs";
import { mdiTagPlus } from "@mdi/js";

import VDatetimeField from "@/components/plugins/vuetify/v-datetime-field.vue";
import NaverSmarteditor from "@/components/plugins/naver/naver-smarteditor.vue";

export default {
    components: {
        VDatetimeField,
        NaverSmarteditor,
    },
    data() {
        return {
            mdiTagPlus,
            ready: false,

            ///////////////////////////////////////////////
            // 게시글 정보
            ///////////////////////////////////////////////
            board: {
                code: this.$route.query.code,

                subject: undefined,
                content: undefined,
                summary: undefined,
                period: undefined,
                updatedAt: undefined,
                displayPeriod: {
                    uses: false,
                    beginsAt: null,
                    closesAt: null,
                },

                sequence: 1,

                writer: {
                    name: undefined,
                    phone: undefined,
                    email: undefined,
                },

                thumb: undefined,
                files: [],
            },
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                if (this.$route.params._board) {
                    var { board } = await api.console.boards.get({ _id: this.$route.params._board });
                    board.files = await Promise.all((board.files || []).map(async ({ url }) => await api.getResource(url, true)));
                    if (board.thumb) board.thumb = await api.getResource(board.thumb, true);
                    this.board = board;
                }

                if (!this.$route.params._board === undefined) {
                    var { summary } = await api.console.boards.gets({
                        headers: { skip: 0, limit: 1 },
                        params: {
                            code: this.$route.query.code,
                        },
                    });
                    this.board.sequence = summary.totalCount + 1;
                }

                this.ready = true;
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
            }
        },
        async save() {
            try {
                let { _files = [], files = [], thumb, ...board } = this.board;
                console.log(this.board);
                ////////////////////////////////////////////////////////////////
                // 0. 리소스 삭제
                ////////////////////////////////////////////////////////////////
                if (_files.length > 0) await Promise.all(_files.map(async (_id) => await api.console.boards.files.delete({ _board: board?._id, _id })));

                ////////////////////////////////////////////////////////////////
                // 1. 게시글 저장
                ////////////////////////////////////////////////////////////////
                [{ board }] = [board._id ? await api.console.boards.put(board) : await api.console.boards.post(board)];

                ////////////////////////////////////////////////////////////////
                // 2. 리소스 저장
                ////////////////////////////////////////////////////////////////
                if (thumb) await api.console.boards.postThumb(board, thumb);
                if (files.length > 0) await Promise.all(files.map(async (file, index) => await api.console.boards.files.post({ _board: board?._id, index }, file)));

                alert(this.board._id ? "수정되었습니다" : "저장되었습니다");

                this.$router.go(-1);
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        createObjectURL(file) {
            try {
                return URL.createObjectURL(file);
            } catch (error) {
                return;
            }
        },
    },
};
</script>
